import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import cx from 'classnames';
import config from '@plone/volto/registry';

const HeadingView = (props) => {
  const { className, data } = props;

  if (!data?.headingContent) return null;

  const Element = data.tag || 'h2';
  const show_alignment = !config.blocks?.blocksConfig?.heading?.hide_alignment;

  return (
    <Element
      style={show_alignment ? { textAlign: data.alignment } : {}}
      className={cx('block-heading', className)}
    >
      {data?.headingContent || ''}
    </Element>
  );
};

export default withBlockExtensions(HeadingView);
